"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Adhs = void 0;
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function Adhs({ active }) {
    return (react_1.default.createElement(react_native_svg_1.default, { viewBox: "0 0 48.27 52.52" },
        react_1.default.createElement(react_native_svg_1.G, { id: "Ebene_2" },
            react_1.default.createElement(react_native_svg_1.G, { id: "Ebene_1-2" },
                react_1.default.createElement(react_native_svg_1.G, { id: "Gruppe_42" },
                    react_1.default.createElement(react_native_svg_1.G, { id: "Gruppe_41" },
                        react_1.default.createElement(react_native_svg_1.Path, { id: "Pfad_75", stroke: active ? '#fff' : '#3db384', fill: "none", strokeWidth: 1.13, strokeLinecap: "round", strokeLinejoin: "round", d: "M24,43.52s-.09,5.85,4.78,5.85,9.58-.09,9.58-.09,1.95.27,2.39-2.75.45-2.93.45-2.93l1.24-6.38,5-1L43,25.52s.35-8.6-1.6-13.12A18.6,18.6,0,0,0,27.21,1.23,22.64,22.64,0,0,0,5.93,7.88C.7,13.55-.36,23,1.85,28.53S5.93,35,5.93,38.64V51.76" }),
                        react_1.default.createElement(react_native_svg_1.Path, { id: "Pfad_76", stroke: active ? '#fff' : '#3db384', fill: "none", strokeWidth: 1.13, strokeLinecap: "round", d: "M27.36,11.87a8.63,8.63,0,1,1-7.89.27" })),
                    react_1.default.createElement(react_native_svg_1.Path, { id: "Pfad_77", stroke: active ? '#fff' : '#3db384', fill: "none", strokeWidth: 1.13, strokeLinecap: "round", d: "M12.67,13.05l6.61-1.52,1.52,6.61" }))))));
}
exports.Adhs = Adhs;
